import { Link } from 'react-router-dom';
import { Calendar, CheckSquare, MapPin, MessageCircle, Users } from 'lucide-react';
import { Button, Card } from '@/components/ui';

export function HomePage() {
  return (
    <div className="space-y-4">
      <Card>
        <h2 className="text-lg font-semibold">Hoş Geldiniz</h2>
        <p className="mt-2 text-sm text-muted-foreground">
          Barla, Çamdağı ve maneviyat programlarınızı tek platformda yönetin.
        </p>
        {/* Tek giriş yolu Google; ayrı bir "kayıt ol" adımı yok. İlk
            defa giren için hesap kendiliğinden açılıyor. */}
        <div className="mt-4">
          <Link to="/login" className="block">
            <Button className="w-full">Google ile gir</Button>
          </Link>
        </div>
      </Card>

      <div className="grid grid-cols-2 gap-3">
        {[
          { icon: Calendar, label: 'Program Yönetimi' },
          { icon: CheckSquare, label: 'Checklist' },
          { icon: Users, label: 'Katılımcılar' },
          { icon: MessageCircle, label: 'Grup Sohbeti' },
        ].map(({ icon: Icon, label }) => (
          <Card key={label} className="text-center">
            <Icon className="mx-auto mb-2 h-8 w-8 text-primary" />
            <p className="text-sm font-medium">{label}</p>
          </Card>
        ))}
      </div>

      {/* Gezi rehberi girişsiz okunuyor; programa katılmayan da bakabilsin. */}
      <Link to="/barla" className="block">
        <Card className="flex items-center gap-3">
          <MapPin className="h-7 w-7 shrink-0 text-accent" />
          <div>
            <p className="font-serif text-base font-semibold text-primary">Barla</p>
            <p className="mt-0.5 text-xs leading-relaxed text-muted-foreground">
              Risale-i Nur’un telif edildiği kasaba: gezilecek yerler, Çam Dağı ve konaklama.
            </p>
          </div>
        </Card>
      </Link>
    </div>
  );
}
